const THEME_STORAGE_KEY = "bankari-broker-theme";

export const LIGHT_THEME = "light";
export const DARK_THEME = "dark";

export function getInitialTheme () {
  try {
    const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (storedTheme === DARK_THEME || storedTheme === LIGHT_THEME) return storedTheme;
  } catch (error) {
    // Local storage can be unavailable in private or restricted browser contexts.
  }
  return DARK_THEME;
}

export function applyTheme (theme, persist = true) {
  const normalizedTheme = theme === DARK_THEME ? DARK_THEME : LIGHT_THEME;
  document.documentElement.dataset.theme = normalizedTheme;
  document.documentElement.style.colorScheme = normalizedTheme;

  if (persist) {
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, normalizedTheme);
    } catch (error) {
      // Theme still works for the current session when persistence is unavailable.
    }
  }

  window.dispatchEvent(new CustomEvent("bankari-theme-change", {
    detail: { theme: normalizedTheme },
  }));
  return normalizedTheme;
}
